import React, { useState, useEffect } from 'react';
import { ClipLoader } from 'react-spinners';

import Header from '../header/Header.js';
import Footer from '../footer/Footer.js';
import { getCertificateReportData } from '../../utils/CertificateReportsDataApi.js';
import { filterCentersByFaculty, generatePDF, generateXSL } from '../../utils/CertificateReportUtils.js';
import './certificateReports.css';
import './table.css';

//Dependencias
import CircumIcon from "@klarr-agency/circum-icons-react";

const CertificateReports = ({user}) => {
    const [inputErrors, setInputErrors] = useState({
        nombre: '',
        numeroIdentificacion: '',
    });
    const [loadingData, setLoadingData] = useState(true);
    const [loadingResultData, setLoadingResultData] = useState(false);
    const [resultData, setResultData] = useState(null);

    const [centerFilterValues, setCenterFilterValues] = useState([{label: '--Seleccionar--', value: null}]);
    var facultyFilterValues = (resultData && resultData.facultyFilterValues.length > 1)
    ? [{label: '--Seleccionar--', value: null}, ...resultData.facultyFilterValues]
    : (resultData && resultData.facultyFilterValues.length === 1)
        ? resultData.facultyFilterValues
        : [{label: '--Seleccionar--', value: null}];

    const [filters, setFilters] = useState(() => {
        return {
            numeroIdentificacion: (!user.isAdminRol && user.userDocId) ? user.userDocId : '',
            nombre: (!user.isAdminRol && user.givenName) ? user.givenName : '',
            primerApellido: (!user.isAdminRol && user.middleName) ? user.middleName : '',
            segundoApellido: '',
            centro: [],
            faculty: facultyFilterValues[0]
        }
    });
    const [responseOk, setResponseOk] = useState(false);
    const [filteredRows, setFilteredRows] = useState([]);
    const [filteredRowsSearch, setFilteredRowsSearch] = useState([]);
    const [selectedFaculty, setSelectedFaculty] = useState(null);
    const [notRows, setNotRows] = useState(false);
    const [searchFilter, setSearchFilter] = useState("");

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleFacultyChange = (event) => {
        const { name, value } = event.target;
        setSelectedFaculty(facultyFilterValues.find((faculty) => faculty.value === value));
        let centers = [{label: '--Seleccionar--', value: null}, ...filterCentersByFaculty(value, resultData.reportData)];
        setCenterFilterValues(centers);
        setFilters(prev => ({
            ...prev,
            [name]: value,
            centro: centers[0]
        }));
        setFilteredRows([]);
        setFilteredRowsSearch([]);
    }

    const handleSearcher = (event) => {
        setSearchFilter(event.target.value.toLowerCase());
        if(filteredRowsSearch.length) {
            const searchedRows = filteredRowsSearch.filter(row =>
                row.desc_asignatura?.toLowerCase().includes(event.target.value.toLowerCase())
            );
            setFilteredRows(searchedRows);
            if(!searchedRows.length){
                setNotRows(true);
            }
        }
    }

    function validateFilters() {
        let newErrors = { nombre: '', numeroIdentificacion: '' };
        setInputErrors(newErrors);
        let hasErrors = false;

        if (!filters.numeroIdentificacion.trim() && (!filters.nombre.trim() || !filters.primerApellido.trim())) {
            newErrors.numeroIdentificacion = 'Debe rellenar el campo número de identificación o nombre y apellido.';
            newErrors.nombre = 'Debe rellenar el campo número de identificación o nombre y apellido.';
            hasErrors = true;
        }

        setResponseOk(hasErrors);
        setInputErrors(newErrors);
        return hasErrors;
    }

    async function applyFilters() {
        let hasErrors = validateFilters();
        if(!hasErrors && resultData?.reportData){
            const filteredRows = resultData.reportData.filter(
                row => row.desc_centro === filters.centro && row.doc_identi === filters.faculty
            );
            setFilteredRows(filteredRows);
            setFilteredRowsSearch(filteredRows);
            setSelectedFaculty(facultyFilterValues.find((faculty) => faculty.value === filters.faculty));
            setSearchFilter("");
        }
    };

    async function fetchFaculties() {
        let hasErrors = validateFilters();
        setLoadingResultData(true);

        if(!hasErrors){
            facultyFilterValues = [{label: '--Seleccionar--', value: null}];
            setCenterFilterValues([{label: '--Seleccionar--', value: null}]);
            setFilters(prev => ({
                ...prev,
                faculty: facultyFilterValues[0],
                centro: centerFilterValues[0]
            }));
            setFilteredRows([]);
            setFilteredRowsSearch([]);
            await getCertificateData();
        }
        setLoadingResultData(false);
    }

    async function exportExcel() {
        generateXSL(
            filteredRows,
            facultyFilterValues.find((faculty) => faculty.value === filters.faculty).label
        );
    };

    async function exportPDF(){
        generatePDF(
            filters,
            facultyFilterValues.find((faculty) => faculty.value === filters.faculty).label,
            filteredRows
        );
    }

    async function getCertificateData() {
        try {
            let apellidos = (user && !user.isAdminRol) ? filters.primerApellido + '%' : filters.primerApellido;
            const result = (user && !user.isAdminRol)
                         ? await getCertificateReportData(user.codProf, null, null, null)
                         : await getCertificateReportData(null, filters.numeroIdentificacion, filters.nombre, apellidos);

            setResultData(result);
            if(result && result.facultyFilterValues.length === 1){
                setSelectedFaculty(result.facultyFilterValues[0]);
                let centers = filterCentersByFaculty(result.facultyFilterValues[0].value, result.reportData);
                setCenterFilterValues([{label: '--Seleccionar--', value: null}, ...centers]);
                setFilters(filter => ({
                    ...filter,
                    faculty: result.facultyFilterValues[0].value
                }));
            }
            setResponseOk(true);
        } catch (error) {
            console.error(error);

        } finally {
            setLoadingData(false);
        }
    }

    useEffect(() => {
        console.log(user);

        if(user && !user.isAdminRol){
            getCertificateData();
        } else {
            setLoadingData(false);
        }
    }, []);

    return (
        <div>
            <Header/>
            <div className="report-viewer">
            {loadingData ? (
                <div className="spinner-container">
                    <ClipLoader color="red" loading={loadingData} size={50} />
                </div>
            ) : (
                <div>
                    <div>
                        <div className="form-container">
                            <div className="form-row">
                            <div className="form-group">
                                <label htmlFor="numeroIdentificacion" className={`${inputErrors.numeroIdentificacion ? 'label-error' : ''}`}>Número de identificación (DNI)</label>
                                <input
                                    className={`form-control ${inputErrors.numeroIdentificacion ? 'input-error' : ''}`}
                                    type="text"
                                    id="numeroIdentificacion"
                                    name="numeroIdentificacion"
                                    onChange={handleFilterChange}
                                    value={filters.numeroIdentificacion}
                                    disabled={!user.isAdminRol}
                                />
                                {inputErrors.numeroIdentificacion && <div className="input-error-message">{inputErrors.numeroIdentificacion}</div>}

                            </div>
                            </div>
                            <div className="form-row">
                            <div className="form-row">
                                <div className="form-group">
                                <label htmlFor="nombre" className={`${inputErrors.nombre ? 'label-error' : ''}`}>Nombre</label>
                                <input
                                    className={`form-control ${inputErrors.nombre ? 'input-error' : ''}`}
                                    type="text"
                                    id="nombre"
                                    name="nombre"
                                    onChange={handleFilterChange}
                                    value={filters.nombre}
                                    disabled={!user.isAdminRol}
                                />
                                {inputErrors.nombre && <div className="input-error-message">{inputErrors.nombre}</div>}

                                </div>
                                <div className="form-group margin-info">
                                    <label htmlFor="primerApellido" className={`${inputErrors.nombre ? 'label-error' : ''}`}>Apellidos</label>
                                    <input
                                        className={`form-control ${inputErrors.nombre ? 'input-error' : ''}`}
                                        type="text"
                                        id="primerApellido"
                                        name="primerApellido"
                                        onChange={handleFilterChange}
                                        value={filters.primerApellido}
                                        disabled={!user.isAdminRol}
                                    />
                                </div>
                                </div>
                            </div>
                            {user.isAdminRol ? (
                                <div>
                                    <div className="form-row button-container">
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={fetchFaculties}
                                        >
                                            Buscar profesores
                                        </button>
                                    </div>
                                    <div className="form-row adminFacultySearch">
                                        <div className="form-group">
                                            <label htmlFor="centro">Profesor</label>
                                            <select
                                                className="form-control"
                                                id="faculty"
                                                name="faculty"
                                                onChange={handleFacultyChange}
                                                value={filters.faculty}
                                            >
                                            {facultyFilterValues.map(({ label, value }) => (
                                                <option key={value} value={value}>{label}</option>
                                            ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="centro">Centro</label>
                                    <select
                                        className="form-control"
                                        id="centro"
                                        name="centro"
                                        onChange={handleFilterChange}
                                        value={filters.centro}
                                    >
                                    {centerFilterValues.map(({ label, value }) => (
                                        <option key={value} value={value}>{label}</option>
                                    ))}
                                    </select>
                                </div>
                            </div>
                            <div className="form-row button-container">
                                <button type="button" className="btn btn-primary" onClick={applyFilters}>
                                    Mostrar informe
                                </button>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div>
                        { (loadingResultData) ? (
                            <div>
                                <div className="spinner-inner-container">
                                    <ClipLoader color="red" loading={loadingResultData} size={50} />
                                </div>
                                <h3 className="text-center">Cargando datos</h3>
                            </div>
                        ) : (!filteredRows.length && !notRows && resultData?.reportData.length > 0 ? (
                            <div>
                                <h3 className="text-center">Es necesario seleccionar un profesor y un centro para generar el certificado.</h3>
                            </div>
                        ) : (!filteredRows.length && !notRows ? (
                            <div>
                                <h3 className="text-center">No hay datos disponibles.</h3>
                            </div>
                        ) : (
                            <div>
                                <h3 className='profesor-title'>Certificado del profesor: {selectedFaculty.label} (NIF - {(selectedFaculty.value != null) ? selectedFaculty.value : ''})</h3>
                                <div className="bottom-section">
                                    <div className="left-section">
                                        <div className="export-buttons">
                                            <button onClick={exportExcel} type="button" className="btn btn-secondary"><CircumIcon name="share_1" className="share" size="20px"/>&nbsp; Exportar excel</button>
                                            {user.isAdminRol && (<button onClick={exportPDF} type="button" className="btn btn-secondary"><CircumIcon name="share_1" className="share" size="20px" />&nbsp; Exportar PDF</button>)}
                                        </div>
                                        <CircumIcon name="circle_info" size="25px"/>
                                        <div className="digital-signature">
                                            <p>Si desea solicitar la firma digital, enviar un correo a {
                                                (filters.centro.includes("La Orotava")) ? "calidad.uec@universidadeuropea.es" :
                                                (filters.centro.includes("Valencia")) ? "unidadcalidadvalencia@universidadeuropea.es" :
                                                "calidad@universidadeuropea.es"
                                            }</p>
                                        </div>
                                    </div>
                                    <div className="search-container">
                                        <input type="search" className="search-input" placeholder="Buscar" value={searchFilter} onChange={handleSearcher} />
                                    </div>
                                </div>
                                <table id="reports" className="table-container">
                                    <thead>
                                        <tr>
                                            <th>Curso académico</th>
                                            <th class="subjectColumn">Asignatura</th>
                                            <th class="satisfaction-column">Satisfacción<br />Global<br />(Escala 1 a 5)</th>
                                            <th>Nº Respuestas</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredRows.map((row, index) => (
                                            <tr key={index}>
                                            <td>{row.cur_academ}/{Number(row.cur_academ)+1}</td>
                                            <td class="subjectColumnText">{row.desc_asignatura?.toUpperCase()} ({row.desc_titulacion?.toUpperCase()} - {row.cod_grupo_simple?.toUpperCase()})</td>
                                            <td>{Number(row.med_resp_prof)?.toFixed(2)}</td>
                                            <td>{row.num_resp_prof}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )))}
                    </div>
                </div>
            )}
            </div>
            <Footer className="footer"/>
        </div>
    );
};

export default CertificateReports;